import { httpsCallable } from "firebase/functions";
import type { ExamAttemptData } from "@piano-tutor/shared";
import { getFunctionsAsia } from "./functions";

export interface VerifiedCertificate {
  id: string;
  studentName: string;
  issuedAtIso: string;
  accuracyPct: number | null;
  examsVerified: number;
  course: string;
  status: "valid";
  verificationUrl: string;
}

export async function beginVerifiedExam(
  examId: string,
): Promise<{ sessionId: string; examId: string; timeLimitSec: number }> {
  const fn = httpsCallable<{ examId: string }, {
    sessionId: string;
    examId: string;
    timeLimitSec: number;
  }>(getFunctionsAsia(), "beginVerifiedExam");
  const result = await fn({ examId });
  return result.data;
}

export async function submitVerifiedExam(
  sessionId: string,
  attempt: ExamAttemptData,
): Promise<{
  passed: boolean;
  examId: string;
  accuracyPct: number;
  hits: number;
  wrongs: number;
}> {
  const fn = httpsCallable(getFunctionsAsia(), "submitVerifiedExam");
  const result = await fn({
    sessionId,
    notes: attempt.notes,
    clientDurationMs: attempt.clientDurationMs,
  });
  return result.data as {
    passed: boolean;
    examId: string;
    accuracyPct: number;
    hits: number;
    wrongs: number;
  };
}

export async function issueCourseCertificate(): Promise<VerifiedCertificate> {
  const fn = httpsCallable<Record<string, never>, {
    certificate: VerifiedCertificate;
  }>(getFunctionsAsia(), "issueCourseCertificate");
  const result = await fn({});
  return result.data.certificate;
}
